import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cube";
import "swiper/css/pagination";

// import required modules
import { Pagination, EffectCube } from "swiper";

type ImageSliderProps = {
	images: string[];
};

const ImageSlider = ({ images }: ImageSliderProps): JSX.Element => {
	return (
		<>
			<Swiper
				effect={"cube"}
				grabCursor={true}
				cubeEffect={{
					shadow: true,
					slideShadows: true,
					shadowOffset: 10,
					shadowScale: 0.9,
				}}
				spaceBetween={30}
				pagination={{
					clickable: true,
					bulletClass: "swiper-pagination-bullet",
				}}
				modules={[Pagination, EffectCube]}
				className="bg-white w-full h-full"
			>
				{images.map((image) => {
					return (
						<SwiperSlide key={image}>
							<div className="relative w-full h-full">
								{" "}
								<img
									src={image}
									className="absolute inset-0 w-full h-full object-cover rounded-lg flex-shrink-0"
									alt="..."
								/>
							</div>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</>
	);
};

ImageSlider.defaultProps = { images: [] };

export default ImageSlider;
